import React, {Component} from 'react';
import {
    Routes,
    Route
} from 'react-router-dom';

import Footer from 'components/Footer/Footer.jsx';
import PagesHeader from 'components/Header/PagesHeader';

import pagesRoutes from 'routes/pages';
class Pages extends Component{
    
    constructor(props){
        super(props);
        if(document.documentElement.className.includes('nav-open')){
            document.documentElement.classList.toggle('nav-open');
        }
    }
    render(){
        return (
            <div>
                <PagesHeader />
                <div className="wrapper wrapper-full-page">
                    
                        <div className="content-max">
                            <Routes>
                                {
                                    pagesRoutes.map((prop) => {
                                        return (
                                            <Route path={prop.path} element={<prop.component/>}  key={prop.path}/>
                                        );
                                    })
                                }
                            </Routes>
                        </div>
                        <Footer transparent/>
                        
                    
                </div>
            </div>
        );
    }
}

export default Pages;

